var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "mdc-textfield-container search-input",
      class: _vm.textfieldClassBinding
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "mdc-textfield" }, [
        _c("input", {
          staticClass: "mdc-textfield__input",
          attrs: {
            type: "search",
            id: "search-input",
            placeholder: _vm.$t("common.browse_filters.search_placeholder")
          },
          domProps: { value: _vm.text },
          on: { input: _vm.onInput, focus: _vm.focusInput, blur: _vm.blurInput }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cancel-input-btn", on: { click: _vm.clearInput } },
          [
            _c("img", {
              attrs: { src: "/static/images/icon-cancel.svg", alt: "" }
            })
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "search-input" } }, [
      _c("img", { attrs: { src: "/static/images/icon-search.svg", alt: "" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2eed8ffc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2eed8ffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchInput.vue
// module id = TXtg
// module chunks = 1